// mapelements/VFR.js
import React, { useEffect, useState } from "react";

const VFR = ({ map }) => {

  const [isVisible, setIsVisible] = useState(
    localStorage.getItem("vfrVisible") === "true"
  );

  const toggleVisibility = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);
    localStorage.setItem("vfrVisible", newVisibility.toString()); // Save state
  };

  // Add or remove the VFR layer
  useEffect(() => {
    if (!map) return;

    const layerId = "vfr-bureuo";

    const handleMapLoad = () => {
      if (isVisible) {
        map.setLayoutProperty(layerId, "visibility", "visible");
      } else {
        map.setLayoutProperty(layerId, "visibility", "none");
      }
    };

    if (map) {
      handleMapLoad();
    } else {
      map.on("load", handleMapLoad); // Wait for the map to load
    }

    return () => {
      if (map) {
        map.setLayoutProperty(layerId, "visibility", "none");
      }
      map.off("load", handleMapLoad);
    };
  }, [map, isVisible]);

  return (
    <button
        data-tooltip-id="map-buttons-tooltip"
        data-tooltip-content="VFR reporting points"
        className={`w-8 h-8 ${isVisible ? "bg-gray-600" : "bg-gray-400"} text-white flex items-center justify-center`}
        onClick={toggleVisibility}
    >
      <span role="img" aria-label="VFR" className="text-sm">VFR</span>
    </button>
  );
};

export default VFR;